'use strict';

var Binary = require('./binary');
var Code = require('./code');
var DBRef = require('./db_ref');
var Decimal128 = require('./decimal128');
var Double = require('./double');
var Int32 = require('./int_32');
var Long = require('./long');
var MaxKey = require('./max_key');
var MinKey = require('./min_key');
var ObjectID = require('./objectid');
var BSONRegExp = require('./regexp');
var Symbol = require('./symbol');
var Timestamp = require('./timestamp');

module.exports = {
  Binary: Binary,
  Code: Code,
  DBRef: DBRef,
  Decimal128: Decimal128,
  Double: Double,
  Int32: Int32,
  Long: Long,
  MaxKey: MaxKey,
  MinKey: MinKey,
  ObjectID: ObjectID,
  BSONRegExp: BSONRegExp,
  Symbol: Symbol,
  Timestamp: Timestamp
};



// WEBPACK FOOTER //
// ./~/mongodb-extjson/lib/bson/index.js